<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <li :class="{selected}">
    <router-link v-if="useRouterLink" :to="absoluteTo"><slot /></router-link>
    <a v-else :href="to" :target="target" @click.prevent><slot /></a>
  </li>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  to: {default: ""},
  selected: {default: false},
  target: {default: ""}
});

const useRouterLink = computed(() => {
  if (!props.to) return false;
  if (props.to.startsWith("http")) return false;
  if (props.to.startsWith("#")) return true;
  return true; // shouldn't be needed?
});

const absoluteTo = computed(() => {
  if (props.to.startsWith("#")) return props.to;
  if (props.to.startsWith("/")) return props.to;
  return `/${props.to}`; // prepend leading slash if missing
});
</script>

<style scoped>
li {
  list-style-type: none;
  text-align: right;
  letter-spacing: 0.03em;
  border: none;
}
a:hover {
  text-decoration: none;
}
li.selected :is(a, a:hover) {
  color: var(--brand-color) !important; /* override colors from parent */
}
/* the current page: no dimming on hover, a click goes nowhere new (DESIGN.md § 15) */
li.selected a:hover {
  opacity: 1 !important;
}
</style>
